export const mapRoles = (role) => {
  switch (role) {
    case "teamUser":
      return "Mitglied";

    case "teamAdmin":
    case "superAdmin":      
      return "Administrator";

    default:
      return "Mitglied";
  }
};